import ReportsMenu from "./ReportsMenu";
import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import WingsDropDown from "../Shared/WingsDropDown";
import { toast, ToastContainer } from "react-toastify";
import { NavLink, Link } from "react-router-dom";
import moment from "moment";
import Pagination from "../General/Pagination";
import { Form } from "react-bootstrap";
import csvDownload from "json-to-csv-export";
import ClassesDropDown from "../Shared/ClassesDropDown";
import SectionDropDown from "../Shared/SectionDropDown";
import Select from "react-select";

const ReceiveableFeeReport = () => {
    const [AccessKey] = useState(localStorage.getItem("AccessKey"));
    const [UserID] = useState(localStorage.getItem("ID"));
    const [MemberType] = useState(localStorage.getItem("MemberType"));
    const [showFilters] = useState(true);

    const [loading, setLoading] = useState(false);
    const [listOfLedger, setLedger] = useState([]);
    const [loaddata, setLoaddata] = useState(false);
    const [pageNo, setPageNo] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalRecords, setTotalRecords] = useState(0);

    const [WingId, setWingId] = useState(0);
    const [SessionId] = useState(localStorage.getItem("DefaultSession"));
    const [StartDate, setStartDate] = useState(moment().startOf("month").format("YYYY-MM-DD"));
    const [EndDate, setEndDate] = useState(moment().endOf("month").format("YYYY-MM-DD"));
    const [ShowReceivedFee, setShowReceivedFee] = useState(false);
    const [FeeTypes, setFeeTypes] = useState([]);
    const [FeetypeID, setFeetypeID] = useState(0);
    const [TotalReceived, setTotalReceived] = useState(0);
    const [TotalReceiveableFee, setTotalReceiveableFee] = useState(0);
    const [TotalFeeAmount, setTotalFeeAmount] = useState(0);
    const [ClassId, setClassId] = useState(0);
    const [SectionID, setSectionID] = useState(0);
    const [hasSearched, setHasSearched] = useState(false);

    const amountLabel = ShowReceivedFee ? "Received Fee" : "Receivable Fee";
    const dateColumnLabel = ShowReceivedFee ? "Received Date" : "Posting Date";

    const buildRequestData = (overridePageSize, overridePageNo) => ({
        AccessKey,
        UserID,
        MemberType,
        pageNo: overridePageNo != null ? overridePageNo : pageNo,
        pageSize: overridePageSize || pageSize,
        StartDate,
        EndDate,
        ShowReceivedFee,
        Wing_Id: WingId,
        FeeTypeId: FeetypeID,
        Class_Id: ClassId,
        Section_Id: SectionID,
    });

    const buildExportRequestData = () => buildRequestData(10000000, 1);

    const validateFilters = () => {
        if (!StartDate || !EndDate) {
            toast.error("Please select start and end dates.");
            return false;
        }
        if (moment(EndDate).isBefore(moment(StartDate), "day")) {
            toast.error("End date must be on or after start date.");
            return false;
        }
        if (!FeetypeID) {
            toast.error("Please select a fee head.");
            return false;
        }
        return true;
    };

    useEffect(() => {
        document.title = ShowReceivedFee
            ? "Received Fee Report"
            : "Receivable Fee Report";
    }, [ShowReceivedFee]);

    useEffect(() => {
        if (!hasSearched) {
            return;
        }
        if (!validateFilters()) {
            return;
        }

        setLoading(true);

        axios({
            method: "post",
            url: config.base_url + "Reports/GetReceiveableFeeReport",
            headers: { "Content-Type": "application/json" },
            data: buildRequestData(),
        })
            .then((response) => {
                if (response.data.status_code === 1) {
                    setLedger(response.data.ListofRecords || []);
                    setTotalRecords(response.data.totalRecords || 0);
                    setTotalReceiveableFee(response.data.TotalReceiveableFee || 0);
                    setTotalReceived(response.data.TotalReceived || 0);
                    setTotalFeeAmount(
                        response.data.TotalFeeAmount != null
                            ? response.data.TotalFeeAmount
                            : ShowReceivedFee
                                ? response.data.TotalReceived
                                : response.data.TotalReceiveableFee
                    );
                } else {
                    setLedger([]);
                    setTotalRecords(0);
                    if (response.data.status_message) {
                        toast.error(response.data.status_message);
                    }
                }
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
                toast.error("Network error.");
            });
    }, [
        hasSearched,
        pageNo,
        pageSize,
        WingId,
        FeetypeID,
        StartDate,
        EndDate,
        ShowReceivedFee,
        ClassId,
        SectionID,
    ]);

    useEffect(() => {
        axios({
            method: "post",
            url: config.base_url + "FeeType/GetFeeTypes",
            headers: { "Content-Type": "application/json" },
            data: {
                AccessKey,
                UserID,
                MemberType,
                PageNo: 1,
                PageSize: 100,
                SchoolID: 1,
            },
        })
            .then((response) => {
                setFeeTypes(response.data.ListofRecords || []);
            })
            .catch(() => {});
    }, []);

    const handlePageChange = (page) => {
        setPageNo(page);
    };

    const handleSearch = (event) => {
        event.preventDefault();
        if (!validateFilters()) {
            return;
        }
        setPageNo(1);
        setHasSearched(true);
    };

    const formatFeeDate = (item) => {
        const raw = item.Fee_Date || (ShowReceivedFee ? item.ReceivedDate : item.PostingDate);
        if (!raw) {
            return "-";
        }
        return moment(raw).format("DD-MMM-YYYY");
    };

    const getRowAmount = (item) => {
        if (item.FeeAmount != null) {
            return item.FeeAmount;
        }
        return ShowReceivedFee ? item.ReceivedAmount : item.ReceiveableFee;
    };

    const handleSubmitForCvs = () => {
        if (!validateFilters()) {
            return;
        }

        setLoaddata(true);

        axios({
            method: "post",
            url: config.base_url + "Reports/GetReceiveableFeeReport",
            headers: { "Content-Type": "application/json" },
            data: buildExportRequestData(),
        })
            .then((response) => {
                if (response.data.status_code === 1 && response.data.totalRecords > 0) {
                    const rows = response.data.ListofRecords || [];
                    let count = 1;
                    const listOfLedgerNew = rows.map((rest) => {
                        const row = {
                            Serial_No: count++,
                            Student_ID: rest.Student_ID,
                            RegNo: rest.Registration_No || "",
                            Name: rest.Student_Name || "",
                            Father_Name: rest.Father_Name || "",
                            Class_Name: `${rest.Class_Name || ""} - ${rest.Section_Name || ""}`.trim(),
                            Fee_Head: rest.Father_CNIC || "",
                        };
                        row[dateColumnLabel] = formatFeeDate(rest);
                        row[amountLabel] = getRowAmount(rest);
                        return row;
                    });

                    const exportTotal =
                        response.data.TotalFeeAmount != null
                            ? response.data.TotalFeeAmount
                            : ShowReceivedFee
                                ? response.data.TotalReceived
                                : response.data.TotalReceiveableFee;

                    const totalRow = {
                        Serial_No: "",
                        Student_ID: "",
                        RegNo: "",
                        Name: "",
                        Father_Name: "",
                        Class_Name: "",
                        Fee_Head: "Total",
                    };
                    totalRow[dateColumnLabel] = "";
                    totalRow[amountLabel] = exportTotal ?? "";
                    listOfLedgerNew.push(totalRow);

                    csvDownload({
                        data: listOfLedgerNew,
                        filename: ShowReceivedFee ? "ReceivedFeeReport" : "ReceivableFeeReport",
                        delimiter: ",",
                        headers: [
                            "Serial_No",
                            "Student_ID",
                            "RegNo",
                            "Name",
                            "Father_Name",
                            "Class_Name",
                            "Fee_Head",
                            dateColumnLabel,
                            amountLabel,
                        ],
                    });
                } else if (response.data.status_code === 1 && response.data.totalRecords === 0) {
                    toast.error("There is no data available for download");
                } else {
                    toast.error(response.data.status_message || "Export failed.");
                }
                setLoaddata(false);
            })
            .catch(() => {
                toast.error("Network Error..");
                setLoaddata(false);
            });
    };

    const renderLedger = () => {
        if (listOfLedger != null && listOfLedger.length > 0) {
            let count = 1;
            return listOfLedger.map((item, index) => (
                <tr key={index}>
                    <td>{count++ + pageSize * (pageNo - 1)}</td>
                    <td>
                        <NavLink
                            target="_blank"
                            to={`/Students/StudentLedger/${item.Student_ID}`}
                            className="red"
                        >
                            {item.Student_ID}
                        </NavLink>
                    </td>
                    <td>{item.Registration_No}</td>
                    <td>{item.Student_Name}</td>
                    <td>{item.Father_Name}</td>
                    <td>
                        {item.Class_Name} - {item.Section_Name}
                    </td>
                    <td>{item.Father_CNIC}</td>
                    <td>{formatFeeDate(item)}</td>
                    <td>{getRowAmount(item)}</td>
                </tr>
            ));
        }

        return (
            <tr>
                <td colSpan="10">
                    <h4 className="mt-3" style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}>
                        {hasSearched ? "No Data Found" : "Select filters and click Search"}
                    </h4>
                </td>
            </tr>
        );
    };

    const dropdownOptions = FeeTypes.map((item) => ({
        value: item.Fee_Type_ID,
        label: `${item.Fee_Type_Name}(${item.Fee_Type_Code})`,
        code: item.Fee_Type_Code,
    }));

    const customStyles = {
        control: (provided) => ({
            ...provided,
            width: "100%",
        }),
    };

    const printUrl =
        `/Reports/ReceiveableFeePrint?StartDate=${StartDate}&EndDate=${EndDate}` +
        `&Wing_Id=${WingId}&FeeTypeId=${FeetypeID}&Class_Id=${ClassId}` +
        `&Section_Id=${SectionID}&ShowReceivedFee=${ShowReceivedFee ? "1" : "0"}`;

    return (
        <>
            <ToastContainer />
            <ReportsMenu />
            <div className="page-head">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-md-6">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <Link to="/Dashboard">Dashboard</Link>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <Link to="/Reports/ReportsDashboard">Reports</Link>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">
                                        {ShowReceivedFee ? "Received Fee Report" : "Receivable Fee Report"}
                                    </li>
                                </ol>
                            </nav>
                            <div className="page-title">
                                {ShowReceivedFee ? "Received Fee Report" : "Receivable Fee Report"}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={`collapse ${showFilters ? "show" : ""} `} id="collapseFilteres">
                <div className="page-content">
                    <div className="container">
                        <div className="card mb-2">
                            <div className="card-body">
                                <Form onSubmit={handleSearch}>
                                    <div className="row">
                                        <div className="col-md-3">
                                            <div className="form-group mb-3">
                                                <label>Start Date</label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    value={StartDate}
                                                    onChange={(e) => setStartDate(e.target.value)}
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group mb-3">
                                                <label>End Date</label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    value={EndDate}
                                                    min={StartDate || undefined}
                                                    onChange={(e) => setEndDate(e.target.value)}
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group mb-3">
                                                <label>Select Wing</label>
                                                <select
                                                    name="Wing_Id"
                                                    onChange={(e) => {
                                                        setWingId(e.target.value);
                                                        setClassId(0);
                                                        setSectionID(0);
                                                    }}
                                                    className="form-select"
                                                >
                                                    <option value="0">---All---</option>
                                                    <WingsDropDown />
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group mb-3">
                                                <label>Select Class</label>
                                                <select
                                                    className="form-select"
                                                    onChange={(e) => {
                                                        setClassId(e.target.value);
                                                        setSectionID(0);
                                                    }}
                                                    name="Class_ID"
                                                >
                                                    <option value="0">---All---</option>
                                                    {SessionId !== 0 && WingId !== 0 && (
                                                        <ClassesDropDown
                                                            SessionID={SessionId}
                                                            WingID={WingId}
                                                        />
                                                    )}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group mb-3">
                                                <label>Select Section</label>
                                                <select
                                                    className="form-select"
                                                    onChange={(e) => setSectionID(e.target.value)}
                                                    name="Section_Id"
                                                >
                                                    <option value="0">---All---</option>
                                                    {ClassId !== 0 && (
                                                        <SectionDropDown ClassID={ClassId} />
                                                    )}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group mb-3">
                                                <label>Select Fee Head</label>
                                                <Select
                                                    styles={customStyles}
                                                    onChange={(selectedOption) =>
                                                        setFeetypeID(selectedOption ? selectedOption.value : 0)
                                                    }
                                                    options={dropdownOptions}
                                                    placeholder="Select fee head..."
                                                    isClearable
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group mb-3 pt-4">
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id="showReceivedFee"
                                                        checked={ShowReceivedFee}
                                                        onChange={(e) => setShowReceivedFee(e.target.checked)}
                                                    />
                                                    <label className="form-check-label" htmlFor="showReceivedFee">
                                                        Show received fee (by received date)
                                                    </label>
                                                </div>
                                                <small className="text-muted">
                                                    Unchecked: receivable fee by posting date.
                                                </small>
                                            </div>
                                        </div>
                                        {loaddata ? (
                                            <div className="col-md-2 offset-md-7 text-center mt-2">
                                                <Spinner animation="border" role="status" />
                                            </div>
                                        ) : (
                                            <div className="col-md-2 offset-md-7 text-end mt-2">
                                                <button
                                                    type="button"
                                                    onClick={handleSubmitForCvs}
                                                    className="print-icon border-0 bg-transparent"
                                                >
                                                    <span>
                                                        <i className="ri-file-excel-2-line"></i>
                                                    </span>
                                                </button>
                                            </div>
                                        )}
                                        <div className="col-md-2 text-end mt-2">
                                            <button
                                                type="submit"
                                                className="w-100 button button-primary"
                                            >
                                                Search
                                            </button>
                                        </div>
                                    </div>
                                </Form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="page-content">
                <div className="container">
                    <div className="card">
                        <div className="card-body">
                            <table className="table table-theme">
                                <thead>
                                    <tr>
                                        <th colSpan={4}>{totalRecords} Records Found</th>
                                        <th colSpan={5} className="text-end">
                                            {amountLabel}: {TotalFeeAmount}
                                        </th>
                                    </tr>
                                </thead>
                                <thead>
                                    <tr>
                                        <th>Sr. No.</th>
                                        <th>Student ID</th>
                                        <th>Registration No</th>
                                        <th>Student Name</th>
                                        <th>Father Name</th>
                                        <th>Class Name</th>
                                        <th>Fee Head</th>
                                        <th>{dateColumnLabel}</th>
                                        <th>{amountLabel}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loading ? (
                                        <tr>
                                            <td className="text-center" colSpan="10">
                                                <Spinner animation="border" role="status" />
                                            </td>
                                        </tr>
                                    ) : (
                                        renderLedger()
                                    )}
                                    {hasSearched && !loading && listOfLedger.length > 0 && (
                                        <tr>
                                            <td colSpan={8} className="text-end">
                                                <strong>Total</strong>
                                            </td>
                                            <td>
                                                <strong>{TotalFeeAmount}</strong>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                            {totalRecords > 10 && (
                                <div className="pagination-wrap">
                                    <div className="row align-items-center">
                                        <div className="col-md-2 form_default">
                                            <div className="d-flex align-items-center">
                                                <label className="me-2" style={{ fontSize: "15px" }}>
                                                    Page Size
                                                </label>
                                                <select
                                                    className="form-select"
                                                    style={{ width: "100px" }}
                                                    value={pageSize}
                                                    onChange={(e) => {
                                                        setPageNo(1);
                                                        setPageSize(parseInt(e.target.value, 10));
                                                    }}
                                                >
                                                    <option value="10">10</option>
                                                    <option value="20">20</option>
                                                    <option value="50">50</option>
                                                    <option value="100">100</option>
                                                    <option value="500">500</option>
                                                    <option value="1000">1000</option>
                                                </select>
                                            </div>
                                        </div>
                                        <Pagination
                                            pageNo={pageNo}
                                            pageSize={pageSize}
                                            totalRecords={totalRecords}
                                            onPageChange={handlePageChange}
                                        />
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className="card mt-2">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-12 text-end">
                                    <NavLink
                                        className="button button-primary"
                                        to={printUrl}
                                        target="_blank"
                                        onClick={(e) => {
                                            if (!validateFilters()) {
                                                e.preventDefault();
                                            }
                                        }}
                                    >
                                        Print Report
                                    </NavLink>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ReceiveableFeeReport;
